import React, { useState } from "react";
import { Col, Row } from "antd";
import SearchControl from "../../../../../components/SearchControls/SearchGroups/SearchControl";
import FilterGroupAccordion, {
  hasActiveValue,
  mergeUnnamedIntoFirst
} from "../../../../../components/SearchControls/SearchGroups/FilterGroupAccordion";
import ModuleSearchGroup from "../ModuleSearchGroup";
import styles from "./style.scss";

const ModuleAllSearchControls = props => {
  const { groupConfigs: rawGroupConfigs, form, onSubmit, onReset, isMobile, showAllControls, renderCategorySelector } = props;
  const groupConfigs = mergeUnnamedIntoFirst(rawGroupConfigs);
  const [explicitOpen, setExplicitOpen] = useState({});

  const getIsOpen = (index, controls) => {
    if (explicitOpen[index] !== undefined) return explicitOpen[index];
    if (hasActiveValue(controls)) return true;
    // First accordion holds the primary fields that were previously the
    // always-visible quick search bar; keep it open so users see them
    // immediately when the panel opens.
    if (index === 0) return true;
    return false;
  };
  const toggleGroup = (index, controls) => {
    setExplicitOpen({ ...explicitOpen, [index]: !getIsOpen(index, controls) });
  };

  return (
    <div style={{ width: "100%" }}>
      {showAllControls && (
        <div>
          {groupConfigs.map((groupConfig, index) => {
            const isOpen = getIsOpen(index, groupConfig.controls);
            // Index 0 reuses ModuleSearchGroup so the primary-fields layout
            // (category selector + span-8 columns) matches the closed-panel
            // quick-search bar one-to-one.
            const body = index === 0 ? (
              <ModuleSearchGroup
                form={form}
                groupConfig={groupConfig}
                onSubmit={onSubmit}
                onReset={onReset}
                isMobile={isMobile}
                renderCategorySelector={renderCategorySelector}
                showAllControls={false}
                hideSearchButton={true}
              />
            ) : (
              <Row type="flex" gutter={12}>
                {groupConfig.controls.map((controlConfig, i) => (
                  <Col span={4} key={i} className={styles.column}>
                    <SearchControl
                      key={i}
                      form={form}
                      controlConfig={controlConfig}
                      isMobile={isMobile}
                      onSubmit={onSubmit}
                      showPlaceholder={true}
                    />
                  </Col>
                ))}
              </Row>
            );
            return (
              <div key={index} className={styles.rowWrapper}>
                <FilterGroupAccordion
                  name={groupConfig.name || "Osnovni podaci"}
                  isOpen={isOpen}
                  onToggle={() => toggleGroup(index, groupConfig.controls)}
                  titleClassName={styles.title}
                >
                  {body}
                </FilterGroupAccordion>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ModuleAllSearchControls;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/ModuleSeaarchSection/ModuleSearchGroups/ModuleAllSearchControls/index.tsx